/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `complete` - Requirement met
 * * `partial` - Short of the requirement
 * * `none` - No records
 */
export type CoverageEnum = typeof CoverageEnum[keyof typeof CoverageEnum];


export const CoverageEnum = {
  complete: 'complete',
  partial: 'partial',
  none: 'none',
} as const;
